"use client";

import { Modal } from "react-bootstrap";
import { useRef, useEffect, useState } from "react";

interface QuestionModalProps {
  showModal: boolean;
  setShowModal: (show: boolean) => void;
  block: {
    questionForm: string;
  };
}

const QuestionModal = (props: QuestionModalProps) => {
  const { showModal, setShowModal, block } = props;
  const form = block?.questionForm;
  const modalBodyRef = useRef<HTMLDivElement>(null);
  const formHasMovedRef = useRef(false);
  const formDivRef = useRef<HTMLDivElement>(null);
  const [formId] = useState(
    () => `question-form-${Math.random().toString(36).substring(2, 9)}`,
  );

  // Watch for form to be populated by HubSpot, move it when ready
  useEffect(() => {
    const questionFormDiv = formDivRef.current;

    if (!questionFormDiv) return;

    // Set up observer from the start to catch when form initializes
    const observer = new MutationObserver(() => {
      const hasChildren = questionFormDiv.children.length > 0;
      const modalBody = modalBodyRef.current;

      // If form has children and modal is open, move them
      if (hasChildren && showModal && !formHasMovedRef.current && modalBody) {
        while (questionFormDiv.firstChild) {
          modalBody.appendChild(questionFormDiv.firstChild);
        }
        formHasMovedRef.current = true;
      }
    });

    observer.observe(questionFormDiv, {
      childList: true,
      subtree: true,
    });

    return () => observer.disconnect();
  }, [showModal]);

  // Handle moving form when modal opens/closes
  useEffect(() => {
    const questionFormDiv = formDivRef.current;
    const modalBody = modalBodyRef.current;

    if (!questionFormDiv || !modalBody) return;

    if (showModal) {
      // If form has already been initialized, move children
      if (questionFormDiv.children.length > 0 && !formHasMovedRef.current) {
        while (questionFormDiv.firstChild) {
          modalBody.appendChild(questionFormDiv.firstChild);
        }
        formHasMovedRef.current = true;
      }
    } else {
      // Move children back to formDiv when modal closes
      if (questionFormDiv && formHasMovedRef.current) {
        while (modalBody.firstChild) {
          questionFormDiv.appendChild(modalBody.firstChild);
        }
        formHasMovedRef.current = false;
      }
    }
  }, [showModal]);

  return (
    <>
      <div
        ref={formDivRef}
        id={formId}
        style={{ display: "none" }}
        suppressHydrationWarning={true}
        dangerouslySetInnerHTML={{
          __html: form || "",
        }}
      />

      <Modal show={showModal} centered onHide={() => setShowModal(false)}>
        <Modal.Header closeButton>
          <Modal.Title>Üzenet küldése</Modal.Title>
        </Modal.Header>
        <Modal.Body ref={modalBodyRef}></Modal.Body>
        <Modal.Footer></Modal.Footer>
      </Modal>
    </>
  );
};

export default QuestionModal;
